import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  totalPages: 0,
  categories: [],
  listLoading: false,
  totalResults: 0,
  actionLoading: false,
};

export const categoriesSlice = createSlice({
  name: "categories",
  initialState: initialState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    getAllCategories: (state, action) => {
      const { categories, totalPages, totalResults } = action.payload;
      state.listLoading = false;
      state.categories = categories;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
    },
  },
});
